import * as actionTypes from '../Actions/LoginActionTypes';

const axiosPayLoad = {
  payload: null
};
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_USER:
      return { ...state, loginUser: action.loginUser };
    case actionTypes.LOGIN_ADMIN:
      return { ...state, loginAdmin: action.loginAdmin };
    case actionTypes.RESET_LOGIN_DATA:
      return { ...state, [action.key]: '' };
    default: return state;
  }
};

export default reducer;
